import { InjectionToken } from '@angular/core';

/**
 * Provided only if the application is server-side rendered.
 * Uses Sec-Ch-Ua-Mobile header to determine if the device is mobile.
 * If no header is present, it will default to parsing the User Agent.
 */
export const DEVICE_TYPE = new InjectionToken<string | undefined>('deviceType');
export const SSR_HYDRATION_PATH = new InjectionToken<string>('ssrHydrationPath');
